var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SocialAuthBtn',{staticClass:"linkedin-btn",attrs:{"img":_vm.LinkedInLogo,"label":_vm.$t('shared.loginModule.socialAuthBtns.continueWithLinkedIn'),"color":"#0077b5","tiny":_vm.tiny},on:{"click":_vm.lLogIn}})}
var staticRenderFns = []

export { render, staticRenderFns }